import {
  ErrorResponseCodeType,
  EndPointsNames,
  ApiCredentialsType,
} from '_core/types';
import { setEntityName } from '_core/util/object';

export const API_DOMAIN: EndPointsNames = 'ApiAccount';
export const ENDPOINT_API_PATH = 'v1/members/maskedContact';
export const ENTITY_NAME = setEntityName(ENDPOINT_API_PATH);
const API_CREDENTIALS_TYPE: ApiCredentialsType = 'TOKEN_CREDENTIALS';
const URL_POSTMAN =
  'https://smiles-sa.postman.co/workspace/Conta~1aa3f7db-730f-4a9e-8904-3201cc3d9669/api/ccee2438-da82-451e-b8cf-bba70981e2ca?version=9a31b461-d71b-4674-b2b0-dc670421150c&tab=overview';

export const CODE_ERRORS: ErrorResponseCodeType[] = [
  {
    code: '1',
    bussinessErrorVariant: 'errorService',
    message:
      'Ocorreu um erro técnico (Erro inesperado, favor contactar a Smiles)',
  },
  {
    code: '202',
    bussinessErrorVariant: 'errorService',
    message:
      'Não foi possível acessar sua conta. Para maiores informações, entre em contato com a central de atendimento Smiles.',
  },
  {
    code: '203',
    bussinessErrorVariant: 'userPreIdentificated',
    message: 'Membro com status Pre Cadastro Banco.',
  },
  {
    code: '204',
    bussinessErrorVariant: 'notValid',
    message: 'Status da conta requer validação',
  },
  {
    code: '21',
    bussinessErrorVariant: 'emailOrPhoneNotValid',
    message: 'Usuário não tem celular nem e-mail validado.',
  },
  {
    code: '45',
    bussinessErrorVariant: 'wrongParams',
    message: 'Parametros de entrada insuficientes.',
  },
];

export default {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
  ENTITY_NAME,
};
